export default "__VITE_ASSET__DnIFLbep__"